<template>
  <div class="text-referal">
    <h1>Дні народження</h1>
    <b-tabs content-class="mt-3">
      <b-tab title="Клиєнти">
        <b-table striped hover :items="userData()" :fields="fields"></b-table>
      </b-tab>
      <b-tab title="Тренери">
        <b-table
          striped
          hover
          :items="trainerData()"
          :fields="trainerfields"
        ></b-table>
      </b-tab>
    </b-tabs>
    <birthday-notifier v-bind:birthdays="todayTrainers" />
  </div>
</template>
<script>
// TODO СДЕЛАТЬ ТАБЛИЦЫ С ЗАВТРАШНИМИ ДНЯМИ РОЖДЕНИЯ , АПИ ЕСТЬ!
import { mapActions } from "vuex";
import BirthdayNotifier from "@/components/modals/BirthdayNotifier";
var moment = require("moment");
var axios = require("axios");
export default {
  name: "BirthdayList",
  components: {
    BirthdayNotifier,
  },
  data: function () {
    return {
      clients: [],
      todayClients: [],
      tomorrowClients: [],
      todayTrainers: [],
      tomorrowTrainers: [],
      trainers: [],
      fields: [
        { name: "Ім'я" },
        { date: "Дата народження" },
        { phonenum: "Номер телефону" },
        { active: "Активний" },
      ],
      trainerfields: [
        { name: "Ім'я" },
        { date: "Дата народження" },
        { phonenum: "Номер телефону" },
      ],
    };
  },
  async mounted() {
    await this.getClients();
    if (this.todayTrainers.length) {
      this.$root.$emit("bv::show::modal", "modal-birthday-notifications");
    }
  },
  methods: {
    ...mapActions(["logOutUser"]),
    async getClients() {
      await axios
        .get(`${process.env.VUE_APP_API}/clients/get/birthday/?clients=yes`, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get("access_token")}`,
          },
        })
        .then((response) => {
          this.todayClients = response.data.Message.Today;
          this.tomorrowClients = response.data.Message.Tomorrow;
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.logOutUser();
          }
        });
      await axios
        .get(`${process.env.VUE_APP_API}/clients/get/birthday/?trainers=yes`, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get("access_token")}`,
          },
        })
        .then((response) => {
          this.todayTrainers = response.data.Message.Today;
          this.tomorrowTrainers = response.data.Message.Tomorrow;
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.logOutUser();
          }
        });
    },
    userData() {
      let options = [];
      this.todayClients.forEach((client) => {
        options.push({
          name: client.name + " " + client.surname,
          date: client.birthday,
          phonenum: client.phonenum,
          active: client.active ? "Активний" : "Неактивний",
        });
      });
      return options;
    },
    trainerData() {
      let options = [];
      this.todayTrainers.forEach((trainer) => {
        options.push({
          name: trainer.name + " " + trainer.surname,
          date: trainer.birthday,
          phonenum: trainer.phonenum,
        });
      });
      return options;
    },
    filters: {
      moment: function (date) {
        return moment(date).format("DD.MM");
      },
    },
  },
};
</script>

<style scoped></style>
